import { graphql } from "react-relay";

export const DELETE_DISCOUNT_ACTION_MUTATION = graphql`
	mutation deleteDiscountActionButton_DeleteDiscountActionMutation(
		$input: DeleteDiscountActionInput!
	) {
		Admin {
			Billing {
				deleteDiscountAction(input: $input) {
					clientMutationId
				}
			}
		}
	}
`;
